import React from "react";

const PageNotFound = () => {
  return (
    <>
      <h1>Page not found</h1>
    </>
  );
};

export default PageNotFound;
